import { format } from 'date-fns'

import { getCampaignInitialValues } from '../../../UploadAdCreative/UploadAdCreativeCampaignForm/fields'
import { toPascalCase } from '../../../UploadAdCreative/UploadAdCreativeCampaignForm/Steps/CampaignNameStep/CampaignNameFields/helpers'

import { OBJECTIVE } from '../../../CampaignForms/fields'
import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../reusableFields'
import { AUTOMATIC, OUTCOME_AWARENESS } from '../../../../../constants/campaigns'
import { DIGITAL_ALLOCATION_TYPE_IMPRESSIONS } from '../../../Partnerships/RightForms/fields'
import { BIDDING_TYPE } from '../../../../Facebook/CampaignForms/CampaignFacebookCreate/CampaignFacebookCreateForm/fields'
import { APPLICATION_ID } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/reusableFields/AppListField/fields'
import { FACEBOOK_AND_TIKTOK } from './PlatformsFieldWrapper/fields'
import { FACEBOOK_PLATFORM, TIKTOK_PLATFORM } from '../../../../../constants/selectLists/platformList'

// NEW FORM
export const NAME = 'name'
export const PLATFORMS = 'platforms'

// OLD FORM
export const BUDGET_LIFETIME = 'budget_lifetime'
export const BUDGET_LIFETIME_LINE_ITEM = 'budget_lifetime_line_item'
export const BUDGET_DAILY_LINE_ITEM = 'budget_daily_line_item'

export const IOS_14_CAMPAIGN = 'ios14'

// Types and Interfaces
interface GetInitialValuesParams {
  isCampaignsExist: boolean
  rightAllocationType: string
  selectedPartnership: {
    rights_holder_name?: string
    partner_name?: string
  }
  selectedFacebookAdAccountId: string | number
  selectedTikTokAdAccountId: string | number
}

interface InitialValues {
  [OBJECTIVE]: string
  [AUTO_OPTIMIZED_CAMPAIGN_BUDGET]: boolean
  [BUDGET_LIFETIME]: string
  [BIDDING_TYPE]: string
  [APPLICATION_ID]: string
  [IOS_14_CAMPAIGN]: boolean
  [key: string]: any
}

export const getInitialValues = ({
  isCampaignsExist,
  rightAllocationType,
  selectedPartnership = {},
  selectedFacebookAdAccountId,
  selectedTikTokAdAccountId
}: GetInitialValuesParams): InitialValues => {
  const campaignsInitialValues = getCampaignInitialValues(isCampaignsExist)
  const { rights_holder_name: rightsHolderName, partner_name: partnerName } = selectedPartnership

  const formattedTodayDate = format(new Date(), 'yyyyMMdd')

  const defaultNameParts = [toPascalCase(rightsHolderName), toPascalCase(partnerName), formattedTodayDate]

  const isBothPlatformsLinked = selectedFacebookAdAccountId && selectedTikTokAdAccountId
  const initialPlatforms = isBothPlatformsLinked
    ? FACEBOOK_AND_TIKTOK
    : selectedFacebookAdAccountId
      ? FACEBOOK_PLATFORM
      : TIKTOK_PLATFORM

  return {
    ...campaignsInitialValues,
    // Pre-populated with rh name, partner name and todays date
    [NAME]: defaultNameParts.filter(Boolean).join('_'),
    [PLATFORMS]: initialPlatforms,
    [OBJECTIVE]: rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS ? OUTCOME_AWARENESS : '',
    [AUTO_OPTIMIZED_CAMPAIGN_BUDGET]: true,
    [BUDGET_LIFETIME]: '',
    [BIDDING_TYPE]: AUTOMATIC,
    [APPLICATION_ID]: '',
    [IOS_14_CAMPAIGN]: false
  }
}
